<template>
  <div>
    <ul class="top-info">
      <li class="text">
        <p class="title">1:1 문의하기</p>
        <p>전남드래곤즈에 1:1 문의하기입니다.</p>
      </li>
    </ul>
    <div class="contact-us">
      <table class="time-table">
        <caption>1:1 문의하기 내역</caption>
        <thead>
        <tr>
          <td v-for="(item, index) in theadList" :key="index">{{item}}</td>
        </tr>
        </thead>
        <tbody v-for="(item, index) in contactUsList" :key="index">
        <tr>
          <td class="title">
            <p>{{item.question}}</p>
          </td>
          <td>{{item.reg_date}}</td>
          <td class="answer">
            <button
                v-if="item.answer"
                class="open-btn" :class="{isOpen: item.isOpen}"
                @click="qnaCloseFunc(item.isOpen, index);"
            >
              {{ item.isOpen ? '답변닫기' : '답변보기'}}
            </button>
            <span v-else>-</span>
          </td>
        </tr>
        <tr v-if="item.isOpen">
          <td colspan="3" class="qna-td">
            <ul class="qna-ul">
              <li class="title">문의 내용</li>
              <li>
                <p class="title" v-html="htmlConverter(item.question)"></p>
              </li>
              <li class="title">답변 내용</li>
              <li>
                <p class="title" v-html="htmlConverter(item.answer)"></p>
              </li>
            </ul>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!contactUsList.length" class="tbody-empty">
        <tr>
          <td colspan="3" class="center">
            <div class="empty"></div>
            <p>등록하신 문의사항이 없습니다.</p>
          </td>
        </tr>
        </tbody>
      </table>

      <router-link :to="{name: 'contactUsWrite'}">
        <button class="login-btn">문의하기</button>
      </router-link>
    </div>
  </div>
</template>

<script>
import {htmlConverter} from '@/lib';
import dayjs from "dayjs";

export default {
  name: 'ContactUs',
  data() {
    return {
      theadList: ['문의하기 제목', '작성일자', '답변여부'],
      contactUsList: [],
      isOpen: false
    }
  },
  mounted () {
    this.getContactUsList();
  },
  methods: {
    htmlConverter,
    async getContactUsList() {

      const {data} = await this.$http.get('/notice/qna');
      if(data.success) {
        this.contactUsList = data.data;
        this.contactUsList.map(item => {
          item.reg_date = dayjs(item.reg_date).format('YYYY-MM-DD');
          item.isOpen = false;
        })
      }

    },
    qnaCloseFunc(isOpen, idx) {
      Object.entries(this.contactUsList).forEach(([, value]) => {
        value.isOpen = false;
      });

      const newList = [...this.contactUsList];
      if(!isOpen) {
        newList[idx].isOpen = !newList[idx].isOpen;
      }
      this.contactUsList = newList;

    }
  }
}
</script>
